// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Hpxu","rootNoMargin":"styles_rootNoMargin__2B97g"};